import { Controller } from "@hotwired/stimulus"

const STEPS = [
  { label: "N/A",       months: null },
  { label: "3 months",  months: 3    },
  { label: "6 months",  months: 6    },
  { label: "12 months", months: 12   },
  { label: "2 years",   months: 24   },
  { label: "3 years",   months: 36   },
  { label: "4 years",   months: 48   },
  { label: "5 years",   months: 60   }
]

export default class extends Controller {
  static targets = ["slider", "label", "hidden", "display"]

  connect() {
    this.update()
  }

  update() {
    const step = STEPS[this.sliderTarget.value]
    this.labelTarget.textContent = step.label

    if (step.months === null) {
      this.hiddenTarget.value = ""
      this.displayTarget.textContent = ""
    } else {
      const date = new Date()
      date.setMonth(date.getMonth() + step.months)
      this.hiddenTarget.value = date.toISOString().split("T")[0]
      this.displayTarget.textContent =
        "Expires " + date.toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric" })
    }
  }
}
